import React from 'react';
import SemLogo from '@iso/assets/images/semLogo.png';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import { formatPhoneNumber, displayCEP, onlyNumber } from '@iso/lib/helpers/utility';

let haveLogo = false;
let employeLogoDimensions = [170,65];
const image = sessionStorage.getItem('employeLogo');

if(image !== null && typeof image !== 'undefined') {
    haveLogo = true;
    employeLogoDimensions = sessionStorage.getItem('employeLogoDimensions').split('x');
}

const styles = StyleSheet.create({
    fragmentContainer: {
        width: '100%',
        flexDirection: 'row',
        height: 70,
    },
    logoContain: {
        width: '50%',
        textAlign: 'left'
    },
    logo: {
        paddingTop: '10px',
        marginHorizontal: '10%',
        width: employeLogoDimensions[0], 
        height: employeLogoDimensions[1]
    },
    dataContain: {
        width: '50%',
        textAlign: 'right'
    },
    label: {
        fontSize: 10
    }
});

const TopProposal = ({invoice}) => {

    const displayDocument = (val) => {
        let ret = '';
        if (onlyNumber(val).length === 11)
            ret = `CPF: ${val}`
        else
            ret = `CNPJ: ${val}`
        return ret;
    }

    return (
        <View style={styles.fragmentContainer}>
            <View style={styles.logoContain}>
                <Image style={styles.logo} src={(haveLogo) ? image : SemLogo} alt={invoice?.icon[0]?.label} />
            </View>
            <View style={styles.dataContain}>
                <Text style={styles.label}>{invoice.fantasyName}</Text>
                {(invoice.address && invoice.address?.address) ?
                    <Text style={styles.label}>{`${invoice.address?.address}, ${invoice.address?.number}`}</Text>
                    : ''}
                {(invoice.address && invoice.address?.cep) ?
                    <Text style={styles.label}>{`${displayCEP(onlyNumber(invoice.address?.cep))} - ${invoice.address?.city}/${invoice.address?.state}`}</Text>
                    : ''}
                <Text style={styles.label}>Telefone: {formatPhoneNumber(onlyNumber(invoice.fone))}</Text>
                {(invoice.cpf_cnpj) ?
                    <Text style={styles.label}>{displayDocument(invoice.cpf_cnpj)}</Text>
                    : ''}
            </View >
        </View>
    )
};

export default TopProposal